function configBase() {
	$('.focus-select').focus(function() {
		$(this).select();
	});

	$('.abas-toggle').click(function() {
		$('.abas-seletores').toggle();
	});

	// links com a classe 'js-voltar' voltam uma página na história
	$('a.js-voltar').click(function() {
		history.back();
		return false;
	});

	// funcionalidade de impressão
	$('a.js-imprimir').click(function() {
		window.print();
		return false;
	});

	// links com rel="external" abrirão em outra página
	$("a[rel='external']").click(function() {
		window.open( $(this).attr('href') );
		return false;
	});

	$('a.excluir-imagem').click(function() {
		if(confirm('Confirma a exclusão da imagem?')) {
			return true;
		} else {
			return false;
		}
	});

	$('a.excluir').click(function() {
		if(confirm('Confirma a exclusão deste item?')) {
			return true;
		} else {
			return false;
		}
	});

	$('a.duplicar').click(function() {
		if(confirm('Confirma a duplicação deste item?')) {
			return true;
		} else {
			return false;
		}
	});

	/*
	-- Tratamento de campos
	*/

	$('.input-limpa').blur(function() {
		$(this).val(remove_extra($(this).val()).toUpperCase());
	});

	$('.input-email').blur(function() {
		$(this).val($(this).val().toLowerCase());
	});

	// redirect select
	if($(".sl-redirect").length > 0) {
		$(".sl-redirect").change(function() {
			var valor = $(this).val();
			location.href = valor;
		});
	}

	// consultar

	if($('body').hasClass('bd-consultar')) {
		$('form.disable-campos input, form.disable-campos select, form.disable-campos textarea, form.disable-campos button').prop('disabled', true);
		$('.detalhes-controles').hide();
		//tinymce.destroy();
	}
}

export default configBase
